<template>
  <div class="card">
    <div class="card-header">
      <slot name="header">
        <div class="card-header--title-area">
          <h5>{{ header }}</h5>
              <span v-if="isLive" class="live">
            <span class="ellipse" /><span>{{
              $t('OVERVIEW_REPORTS.LIVE')
            }}</span>
          </span>
          <div
            v-if="!controlsBelowHeader"
            class="card-header--control-area ml-[8px]"
          >
            <slot name="header-control" />
          </div>
        </div>
        <div
          class="card-header--control-area"
          :class="{ 'card-header--control-area--stacked': controlsBelowHeader }"
        >
          <slot name="control" />
        </div>
      </slot>
    </div>
    <div v-if="!isLoading" class="card-body row">
      <slot />
    </div>
    <div v-else-if="isLoading" class="conversation-metric-loader">
      <spinner />
      <span>{{ loadingMessage }}</span>
    </div>
  </div>
</template>
<script>
import Spinner from 'shared/components/Spinner.vue';

export default {
  name: 'MetricCard',
  components: {
    Spinner,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: '',
    },
    isLive: {
      type: Boolean,
      default: true,
    },
    /** When true, the #control slot spans the full header width on the row below the title. */
    controlsBelowHeader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  @apply bg-white dark:bg-slate-800 border-slate-75 dark:border-slate-700;
  margin: var(--space-small) !important;
}

.card-header {
  grid-template-columns: repeat(auto-fit, minmax(max-content, 50%));
  gap: var(--space-small) 0px;
  @apply grid flex-grow w-full mb-6;

  .card-header--title-area {
    @apply flex items-center flex-row;

    h5 {
      @apply mb-0 text-slate-800 dark:text-slate-100;
    }

    .live {
      background: rgba(37, 211, 102, 0.1);
      @apply flex flex-row items-center pr-2 pl-2 m-1 text-green-400 dark:text-green-400 text-xs;

      .ellipse {
        @apply bg-green-400 dark:bg-green-400 h-1 w-1 rounded-full mr-1 rtl:mr-0 rtl:ml-0;
      }
    }
  }

  .card-header--control-area {
    @apply flex flex-row items-center justify-end gap-2;
  }

  .card-header--control-area--stacked {
    grid-column: 1 / -1;
    justify-content: flex-start;
  }
}

.card-body.row:has(> .metric-content) {
  @apply flex min-w-0 gap-2;
}

.card-body {
  .metric-content {
    @apply pb-2 min-w-0 flex-1;
    .heading {
      @apply text-base text-slate-700 dark:text-slate-100;
    }
    .metric {
      @apply text-woot-800 dark:text-woot-300 text-xl mb-0 mt-1 tabular-nums leading-tight;
    }
  }
}

.conversation-metric-loader {
  /* Match ~height of .card-body metric row to avoid visible expand/collapse on load */
  @apply items-center flex text-base justify-center py-5 px-4;
  min-height: 5.75rem;
}
</style>
